import React from 'react';
import { RBHBox, RBHImage } from '../../../../../shared/components';
import styles from './styles';
import { useDispatch, useSelector } from 'react-redux';
import { INVITATION_STATE_KEY, InvitationConfig, InvitationFormData, invitationStateSelector } from '../redux/invitation-reducer';
import { InvitationBanner as BannerType } from '../../Invitation/types/banner';
import invitationHero from "../../../../../shared/resources/image/invitation-header.png";
import invitationScbHero from "../../../../../shared/resources/image/invitation-scb-header.png";
import thtplusBanner from "../../../../../shared/resources/image/invitation-banner/thtplus-banner.jpg";
import thtplusVipBanner from "../../../../../shared/resources/image/invitation-banner/thtplus-vip-banner.jpg";
import thtplusScbBanner from "../../../../../shared/resources/image/invitation-banner/thtplus-scb-banner.jpg";
import { InvitationChannel } from '../types/channel';
import { InvitationCampaign } from '../types/campaign';

const BannerFallbackSrc: Record<BannerType, string> = {
	[BannerType.SPECIAL_GP]: invitationHero,
	[BannerType.SPECIAL_GP_SCB]: invitationScbHero,
	[BannerType.THT_PLUS]: thtplusBanner,
	[BannerType.THT_PLUS_VIP]: thtplusVipBanner,
	[BannerType.THT_PLUS_SCB]: thtplusScbBanner,
};

export const InvitationBanner = () => {
	const invitationConfig = useSelector(
		invitationStateSelector(INVITATION_STATE_KEY.CONFIG),
	) as InvitationConfig;
	const invitationForm = useSelector(
		invitationStateSelector(INVITATION_STATE_KEY.FORM),
	) as InvitationFormData;

	const { channel } = useSelector(
		invitationStateSelector(INVITATION_STATE_KEY.FORM),
	) as { channel: string | null };

	let fallbackSrc = channel === InvitationChannel.ScbConnect ? BannerFallbackSrc[BannerType.SPECIAL_GP_SCB] : BannerFallbackSrc[BannerType.SPECIAL_GP];
	if (invitationForm.campaignName === InvitationCampaign.THT_PLUS) {
		fallbackSrc = channel === InvitationChannel.ScbConnect ? BannerFallbackSrc[BannerType.THT_PLUS_SCB] : BannerFallbackSrc[BannerType.THT_PLUS];
	}

	return (
		<RBHBox className='invitation-hero' style={styles.hero}>
			<RBHImage
				className='invitation-hero-image'
				data-testid='invitation-hero-image'
				id='invitation-hero-image'
				src={invitationConfig.banner ?? fallbackSrc}
				onError={(e: React.SyntheticEvent<HTMLImageElement>) => { e.currentTarget.src = fallbackSrc; }}
				style={styles.heroImage}
			/>
		</RBHBox>
	);
};

